import React, { useEffect, useState } from "react";
import speechLogo from "../../assets/Images/speech-evaluation.png";
import axiosinstance from "../../services/axiosInstane";
import { useNavigate, useSearchParams } from "react-router-dom";
import SnackBar from "../../components/SnackBar/SnackBar";
import { redirectOptions, snackbarColor } from "../../config/constants";
import Loader from "../../components/Loader/Loader";
import RegisterInput from "../../components/Input/RegisterInput";
import RegisterButton from "../../components/Button/RegisterButton";
import logo from "../../assets/Images/ES-new-Logo.png";
import axios, { AxiosError } from "axios";
import {
  RedirectOptionsProps,
  UserByEmailProps,
} from "../../interfaces/Interface";
import { messages } from "../../config/messages";
import { updateStore } from "../../utils/store";

const Register = () => {
  const navigate = useNavigate();
  const [searchParams, _setSearchParams] = useSearchParams();
  const myParam = searchParams.get("app");
  const isEmailVerified = process.env.REACT_APP_ENABLE_EMAIL_VERIFICATION;
  const [showUserForm, setShowUserForm] = useState(false);
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    organization: "",
    role: "",
    country: "",
  });
  const [snackBarOpen, setSnackBarOpen] = useState({
    value: false,
    message: "",
    type: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [redirectOption, setRedirectOption] = useState<RedirectOptionsProps>({
    id: 0,
    source: "",
    name: "",
    redirectUrl: "",
    image: "",
  });
  const [showEmailVerificationForm, setShowEmailVerificationForm] =
    useState(false);
  const [userId, setUserId] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [isResendButtonDisabled, setIsResendButtonDisabled] = useState(false);

  useEffect(() => {
    redirectOptions.map((option: RedirectOptionsProps) => {
      if (option.source === myParam) {
        setRedirectOption(option);
        document.title = option.name;
      }
    });
    sessionStorage.setItem("userData", JSON.stringify(userDetails));
  }, []);

  const newUser = () => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.name === "phone") {
        const pattern = /^[\d\s+\\-]+$/;
        if (pattern.test(e.target.value)) {
          setUserDetails({ ...userDetails, phone: e.target.value });
        } else {
          setUserDetails({ ...userDetails, phone: "" });
        }
      } else {
        setUserDetails({ ...userDetails, [e.target.name]: e.target.value });
      }
    };

    const onUserSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      setIsLoading(true);
      axiosinstance
        .post("/users", userDetails)
        .then((response) => {
          if (response.status === 201) {
            sessionStorage.setItem("userData", JSON.stringify(userDetails));
            setSnackBarOpen({
              ...snackBarOpen,
              value: true,
              message:
                isEmailVerified === "true"
                  ? messages.emailSentConfirmation
                  : messages.userCreation,
              type: snackbarColor.success,
            });
            checkAppLoginCount(response.data);
            setUserId(response.data.id);
            if (isEmailVerified === "true") {
              setShowUserForm(false);
              setShowEmailVerificationForm(true);
            } else {
              applicationRedirection(response.data.id);
            }
          }
          setIsLoading(false);
        })
        .catch((err: AxiosError) => {
          if (err.response?.status === 400) {
            setSnackBarOpen({
              ...snackBarOpen,
              value: true,
              message: "Please fill all the required fields!",
              type: snackbarColor.error,
            });
          }
          setIsLoading(false);
        });
    };

    const onCancelForm = () => {
      setShowUserForm(false);
      setUserDetails({ ...userDetails, email: "" });
    };

    return (
      <section className="w-[300px] sm:w-[400px] p-4">
        <h1
          className="text-2xl font-semibold text-gray-600"
          aria-label="Enter your details"
        >
          Enter Your Details
        </h1>
        <form onSubmit={onUserSubmit}>
          <div className="mt-5">
            <RegisterInput
              label="First Name"
              htmlFor="first-name"
              name="firstName"
              type="text"
              id="first-name"
              handleChange={handleInputChange}
              required={true}
              tabIndex={0}
            />
            <RegisterInput
              label="Last Name"
              htmlFor="last-name"
              name="lastName"
              type="text"
              id="last-name"
              handleChange={handleInputChange}
              required={false}
              tabIndex={0}
            />
            <RegisterInput
              label="Email"
              htmlFor="email"
              name="email"
              type="text"
              id="email"
              value={userDetails.email}
              disable={true}
              handleChange={handleInputChange}
              required={true}
              tabIndex={0}
            />
            <RegisterInput
              label={`Phone [Only Number, +, - and space allowed]`}
              htmlFor="phone"
              name="phone"
              type="text"
              id="phone"
              value={userDetails.phone}
              handleChange={handleInputChange}
              required={false}
              tabIndex={0}
            />
            <RegisterInput
              label="Organization"
              htmlFor="organization"
              name="organization"
              type="text"
              id="organization"
              handleChange={handleInputChange}
              required={true}
              tabIndex={0}
            />
            <RegisterInput
              label="Role"
              htmlFor="role"
              name="role"
              type="text"
              id="role"
              handleChange={handleInputChange}
              required={true}
              tabIndex={0}
            />
            <RegisterInput
              label="Country"
              htmlFor="country"
              name="country"
              type="text"
              id="country"
              handleChange={handleInputChange}
              required={true}
              tabIndex={0}
            />
          </div>
          <div className="mt-5 flex items-center justify-between space-x-3">
            <RegisterButton
              type="submit"
              label="Submit"
              aria-label="Submit button to activate press enter"
            />
            <RegisterButton
              type="button"
              label="Cancel"
              aria-label="Cancel"
              onClick={onCancelForm}
            />
          </div>
        </form>
      </section>
    );
  };

  const emailVerification = () => {
    const resendEmail = () => {
      setIsResendButtonDisabled(true);
      setTimeout(() => {
        setIsResendButtonDisabled(false);
      }, 30000);
      setIsLoading(true);
      axiosinstance
        .post(`/users/${userId}/resend-code`)
        .then((response) => {
          if (response.status === 200) {
            setSnackBarOpen({
              ...snackBarOpen,
              value: true,
              message: response.data.message,
              type: snackbarColor.success,
            });
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setSnackBarOpen({
            ...snackBarOpen,
            value: true,
            message: error.response.data.message,
            type: snackbarColor.error,
          });
          console.log(error, "error");
          setIsLoading(false);
        });
    };

    const onSubmitVerification = () => {
      axiosinstance
        .post(`/users/${userId}/verify-email`, { code: verificationCode })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.isSuccess === true) {
              axios
                .post(`${process.env.REACT_APP_API_BASEURL}/auth/token`, {
                  userId: response?.data?.id,
                })
                .then((loginResponse) => {
                  if (loginResponse.status === 200) {
                    loginResponse?.data?.accessToken &&
                      updateStore(
                        "token",
                        window.btoa(loginResponse?.data?.accessToken)
                      );
                    loginResponse?.data?.refreshToken &&
                      updateStore(
                        "refreshToken",
                        window.btoa(loginResponse?.data?.refreshToken)
                      );
                    updateStore("source", redirectOption.source);
                    checkAppLoginCount(response.data);
                    setUserId(response.data?.id);
                    applicationRedirection(response.data?.id);
                  }
                })
                .catch((err) => {
                  if (err.response?.status === 404) {
                    setShowUserForm(true);
                  } else {
                    setSnackBarOpen({
                      ...snackBarOpen,
                      value: true,
                      message: err.response?.data?.message,
                      type: snackbarColor.error,
                    });
                  }
                  setIsLoading(false);
                });
            } else {
              setSnackBarOpen({
                ...snackBarOpen,
                value: true,
                message: response.data.message,
                type: snackbarColor.error,
              });
            }
          }
        })
        .catch((error: any) => {
          console.log(error, "error");
        });
    };

    const onResendCancel = () => {
      setShowEmailVerificationForm(false);
    };

    return (
      <div className="w-[300px] sm:w-[400px]">
        <h1
          className="sm:text-2xl text-xl sm:font-semibold text-gray-600 pl-1 mb-2"
          aria-label="Enter Verification Code"
        >
          Enter Verification Code
        </h1>
        <div>Email Id: {userDetails.email}</div>
        <div className="mt-1">
          <RegisterInput
            htmlFor="verification-code"
            name="code"
            type="text"
            id="verification-code"
            placeholder="Enter verification code"
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setVerificationCode(e.target.value)
            }
            required={false}
          />
        </div>
        <div className="mt-5 flex items-center space-x-3">
          <RegisterButton
            type="submit"
            label="Submit"
            aria-label="Submit"
            onClick={onSubmitVerification}
          />
          <RegisterButton
            type="button"
            label="Cancel"
            aria-label="Cancel"
            onClick={onResendCancel}
          />
          <RegisterButton
            type="button"
            label="Resend"
            aria-label="Resend"
            disabled={isResendButtonDisabled}
            onClick={resendEmail}
          />
        </div>
      </div>
    );
  };

  const checkExistingUser = async (event: React.FormEvent<HTMLFormElement>) => {
    sessionStorage.setItem("userData", JSON.stringify(userDetails));
    event.preventDefault();
    if (userDetails.email === "") {
      setSnackBarOpen({
        ...snackBarOpen,
        value: true,
        message: "Please enter your email address.",
        type: snackbarColor.warning,
      });
    } else {
      setIsLoading(true);
      await axios
        .get(
          `${process.env.REACT_APP_API_BASEURL}/users/by-email/${userDetails.email}`
        )
        .then(async (response) => {
          if (response.status === 200) {
            await axios
              .post(`${process.env.REACT_APP_API_BASEURL}/auth/token`, {
                userId: response?.data?.id,
              })
              .then((loginResponse) => {
                if (loginResponse.status === 200) {
                  loginResponse?.data?.accessToken &&
                    updateStore(
                      "token",
                      window.btoa(loginResponse?.data?.accessToken)
                    );
                  loginResponse?.data?.refreshToken &&
                    updateStore(
                      "refreshToken",
                      window.btoa(loginResponse?.data?.refreshToken)
                    );
                  updateStore("source", redirectOption.source);
                  checkAppLoginCount(response.data);
                  setUserId(response.data?.id);
                  if (isEmailVerified === "true") {
                    if (response.data?.isEmailVerified) {
                      applicationRedirection(response.data?.id);
                    } else {
                      setShowEmailVerificationForm(true);
                    }
                  } else {
                    applicationRedirection(response.data?.id);
                  }
                }
              })
              .catch((err) => {
                if (err.response?.status === 404) {
                  setShowUserForm(true);
                } else {
                  setSnackBarOpen({
                    ...snackBarOpen,
                    value: true,
                    message: err.response?.data?.message,
                    type: snackbarColor.error,
                  });
                }
                setIsLoading(false);
              });
          } else {
            setShowUserForm(true);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          if (err.response?.status === 404) {
            setShowUserForm(true);
          } else {
            setSnackBarOpen({
              ...snackBarOpen,
              value: true,
              message: err.response?.data?.message,
              type: snackbarColor.error,
            });
          }
          setIsLoading(false);
        });
    }
  };

  const checkAppLoginCount = (response: UserByEmailProps) => {
    axiosinstance.put(
      `/users/${response.id}/apps/${
        redirectOption.source ? redirectOption.source : "speech"
      }`
    );
  };

  const applicationRedirection = (id: string) => {
    sessionStorage.setItem("userData", JSON.stringify(userDetails));
    switch (redirectOption.source) {
      case "":
        navigate(`/speech-evaluation/${id}`);
        break;
      case "speech":
        navigate(`/speech-evaluation/${id}`);
        break;
      default:
        window.location.href = redirectOption.redirectUrl;
    }
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <main className="sm:flex w-full min-h-screen bg-slate-300">
        <div className="sm:w-1/4 relative bg-slate-100 flex sm:flex-col items-center sm:justify-center justify-between px-3 sm:p-0 text-center">
          <div>
            <div>
              {" "}
              <div className="absolute top-2 left-2 hidden sm:block">
                <img
                  src={logo}
                  alt="Excelsoft logo"
                  className="lg:h-16 sm:h-10"
                />
              </div>
            </div>
            <div className="sm:hidden block">
              <img src={logo} alt="Excelsoft logo" className="sm:h-16 h-12" />
            </div>
            <div className="hidden sm:block">
              <img
                src={
                  redirectOption.source !== ""
                    ? redirectOption.image
                    : speechLogo
                }
                alt={
                  redirectOption.source !== ""
                    ? `${redirectOption.name} logo`
                    : "Speech evaluation logo"
                }
                className="sm:h-40 sm:w-40 h-14 w-14"
              />
            </div>
          </div>

          <div className="ml-5 text-sky-700 sm:text-2xl text-lg sm:p-4 font-semibold">
            {redirectOption.source !== ""
              ? redirectOption.name
              : "Speech Evaluation"}
          </div>
        </div>
        <div className="sm:w-3/4 flex items-center justify-center p-3 sm:p-0 ">
          {!showUserForm && !showEmailVerificationForm && (
            <div className="w-[300px] sm:w-[400px] p-4">
              <div className="sm:hidden flex-col flex items-center justify-center my-4">
                <div className=" bg-white h-16 w-16 flex items-center justify-center rounded-sm shadow-md">
                  <img
                    src={speechLogo}
                    alt="logo"
                    className="sm:h-16 h-14 shadow-lg"
                  />
                </div>
              </div>

              <h1 className="sm:text-2xl font-semibold text-[#354259] pl-1">
                Enter Your Email Address
              </h1>
              <form onSubmit={checkExistingUser}>
                <div className="mt-1">
                  <RegisterInput
                    aria-label="Enter Your Email Address"
                    htmlFor="email"
                    name="email"
                    type="email"
                    id="email"
                    placeholder="eg: bob@gmail.com"
                    handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setUserDetails({
                        ...userDetails,
                        email: e.target.value,
                      })
                    }
                    required={false}
                  />
                </div>
                <div className="mt-5">
                  <RegisterButton
                    type="submit"
                    label="Next"
                    aria-label="Next button to activate press enter"
                  />
                </div>
              </form>
            </div>
          )}
          {showUserForm && newUser()}
          {isEmailVerified === "true" &&
            showEmailVerificationForm &&
            emailVerification()}
        </div>
      </main>
      <SnackBar
        isOpen={snackBarOpen.value}
        handleClose={() => setSnackBarOpen({ ...snackBarOpen, value: false })}
        message={snackBarOpen.message}
        type={snackBarOpen.type}
      />
    </>
  );
};

export default Register;
